import { db, storage, docFromSnapshot } from "../firebase";
import { omitUndefinedDeep } from "@/helpers/helpers";
import { DEFAULT_SHOP, mergeShop } from "@/helpers/shopDefaults";

export { DEFAULT_SHOP, mergeShop };

const SET_SHOP = "SET_SHOP";

const state = {
  shop: DEFAULT_SHOP
};

function sortable(decending) {
  return function (a, b) {
    return a === b ? 0 : a === null ? 1 : b === null ? -1 : decending ? a > b ? -1 : 1 : a > b ? 1 : -1;
  };
}

const getters = {
  shop: state => state.shop,
  shopId: state => state.shop._id,
  shopEarliestOpeningTime: state => {
    const { openingTimes } = state.shop || {};
    // Ignore null/empty closed days so calendar business hours apply
    const vals = Object.values(openingTimes || {}).filter(
      v => typeof v === "string" && v.length > 0
    );
    if (!vals.length) return null;
    return vals.slice().sort()[0];
  },
  shopLatestClosingTime: state => {
    const { closingTimes } = state.shop || {};
    const vals = Object.values(closingTimes || {}).filter(
      v => typeof v === "string" && v.length > 0
    );
    if (!vals.length) return null;
    return vals.slice().sort(sortable(true))[0];
  }
};

const actions = {
  async fetchShop(context) {
    const storeId = context.rootGetters.userClaims.storeId;
    if (!storeId) return;
    const snapshot = await db
      .collection("stores")
      .doc(storeId)
      .get();
    const shop = docFromSnapshot(snapshot);
    context.commit(SET_SHOP, mergeShop(shop));
  },
  async updateShop(context, shop) {
    const tenantId = context.rootGetters.tenantId || shop.tenantId;
    const sid = (context.rootGetters.userClaims || {}).storeId;
    const _id = shop._id || sid;
    const storeId = _id;
    if (!_id || !tenantId) {
      throw new Error("Your book is still opening. Wait a moment and try again.");
    }

    shop = omitUndefinedDeep({
      ...shop,
      _id,
      storeId,
      tenantId,
      lastModified: +new Date()
    });
    await db
      .collection("stores")
      .doc(_id)
      .set(shop, { merge: true });
    context.commit(SET_SHOP, mergeShop(shop));
  },
  async uploadShopLogo({ getters }, payload) {
    const shopId = getters.shopId;
    if (!shopId) {
      throw new Error("Shop is not ready yet.");
    }
    await storage
      .ref()
      .child(`shopLogos/${shopId}`)
      .putString(payload, "data_url");
    return storage
      .ref()
      .child(`shopLogos/${shopId}`)
      .getDownloadURL();
  },
  async updateShopLogo({ dispatch, getters }, payload) {
    const logoDownloadUrl = await dispatch("uploadShopLogo", payload);
    await dispatch("updateShop", {
      ...getters.shop,
      logoDownloadUrl
    });
    return logoDownloadUrl;
  }
};

const mutations = {
  [SET_SHOP](state, shop) {
    state.shop = shop;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
